import React, { useContext, useEffect, useState } from 'react';
import useForm from '../../../helpers/useForm';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import Button from '../../../components/Common/Button/Button';
import { Spinner } from '../../../components/Common/Spinner/Spinner';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getQueryString } from '../../../helpers/url';
import { useDispatch, useSelector } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import { setCanRefresh } from '../../../actions/appActions';
import InputFormBorder from '../../../components/Common/InputFormBorder/InputFormBorder';
import ErrorMapperRegisterLogin from '../../../helpers/ErrorMapperRegisterLogin';
import ErrorBox from '../../../components/Common/ErrorBox/ErrorBox';

const SignUpEmailValidationScreenCustomer = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const phone = getQueryString('phone');
  const token = getQueryString('token');
  const countryCode = getQueryString('countryCode');
  const welletContext = useContext(WelletContext);
  const tenantId = useSelector((state) => state.app.tenantId);
  const dispatch = useDispatch();
  const [verifyingUser, setVerifyingUser] = useState(false);
  const [errorUser, setErrorUser] = useState(undefined);

  useEffect(() => {
    dispatch(setCanRefresh(false));
  }, []);

  function validate(values) {
    let errors = {};
    if (!values.email) {
      errors.email = t('emailError.EMPTY_EMAIL');
    } else if (!values.email.includes('@')) {
      errors.email = t('emailError.EMAIL_@');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
      errors.email = t('emailError.INVALID_EMAIL');
    }
    if (values.email && !values.emailConfirmation) {
      errors.emailConfirmation = t('emailError.EMPTY_EMAIL');
    } else if (values.email !== values.emailConfirmation) {
      errors.emailConfirmation = t('emailError.EMAIL_NOT_MATCH');
    }

    return errors;
  }

  const sendForm = async () => {
    setVerifyingUser(true);
    try {
      const result = await welletContext.apis.tickets.post(`users/register/available`, {
        email: values.email,
        tenantId: tenantId,
      });

      if (result.data.isAvailable) {
        let query =
          '?phone=' +
          phone +
          '&countryCode=' +
          countryCode +
          '&token=' +
          token +
          '&email=' +
          values.email;

        history.push({
          pathname: '/sign-up-create-password-customer',
          search: query,
        });

      } else {
        setErrorUser(<ErrorMapperRegisterLogin errorCode={result.data.availableMessage} />);
      }
    } catch (error) {
      console.error(error);
      setErrorUser(t('errors.SERVER_ERROR'));
    }finally {
      setVerifyingUser(false);
    }
  };

  const onChange = (e) => {
    setErrorUser('');
    handleChange(e);
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  return (
    <>
      <Header />
      <ContentApp background={true}>
        <div className=''>
          <div className='font-medium bold text-white' style={{ lineHeight: '1.6rem' }}>
            {t('enterEmail')}
          </div>
          <div className='mt-2 text-secondary subtitle' style={{ lineHeight: '1.3rem' }}>
            {t('signUp.subtitle3')}
          </div>
          <form onSubmit={handleSubmit}>
            <div className='mt-4 font-normal'>
              <InputFormBorder
                name='email'
                type='email'
                value={values.email || ''}
                error={errors.email}
                label={t('E-mail')}
                placeholder={t('enterEmail')}
                onChange={onChange}
                forceLowecase={true}
              />
            </div>
            <div className='mt-4'>
              <InputFormBorder
                name='emailConfirmation'
                type='email'
                value={values.emailConfirmation || ''}
                error={errors.emailConfirmation}
                label={t('signUp.confirmEmail')}
                placeholder={t('reEnterEmail')}
                onChange={onChange}
                forceLowecase={true}
              />
            </div>
            {errorUser && (
              <div className='mt-5'>
                <ErrorBox title={errorUser} />
              </div>
            )}
            <div className='mt-4'>
              <Button
                size='large'
                fontSize={'18px'}
                text={
                  verifyingUser ? (
                    <div className='d-flex justify-content-center'>
                      <Spinner size={25} color='#000' />
                    </div>
                  ) : (
                    t('continue')
                  )
                }
                icon={verifyingUser ? false : true}
                typeIcon='arrow'
                iconColor='#000'
              />
            </div>
          </form>
        </div>
      </ContentApp>
    </>
  );
};

export default SignUpEmailValidationScreenCustomer;
